@if (isPositionClassVisible) {
  <mat-expansion-panel
    [expanded]="isExpanded"
    [hideToggle]="true">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <div class="left">
          <h4 class="position">{{ 'mercer-support.dialog.position-class' | translate }}</h4>
          @if (memberDetails()?.isPositionClassHidden) {
            <mat-icon
              matTooltip="{{ 'mercer-support.dialog.pc-hidden-reason' | translate }}"
              size="small">
              info
            </mat-icon>
          }
        </div>
        <div class="right">
          @if (!mercerSupportDetailsService.isReadOnly) {
            @if (dialogType() === mercerDialogType.Support) {
              <coin-v2-button
                type="secondary"
                icon="close"
                iconPos="left"
                [disabled]="!isEditable() || !adjustedPositionClass || !isChangeOrAcceptPCAllowed"
                [text]="'mercer-support.dialog.changed-proposed-pc' | translate"
                (click)="changePositionClass.emit(adjustedPositionClass)"></coin-v2-button>
            }
            @if (dialogType() === mercerDialogType.Support) {
              <coin-v2-button
                type="primary"
                icon="check"
                iconPos="left"
                [disabled]="!isEditable() || !isChangeOrAcceptPCAllowed"
                [text]="'mercer-support.dialog.accept-proposed-pc' | translate"
                (click)="acceptProposedPositionClass.emit()"></coin-v2-button>
            }
            @if (dialogType() === mercerDialogType.Manager) {
              <coin-v2-button
                type="primary"
                icon="check"
                iconPos="left"
                [disabled]="!isSentToHrAllowed || (requestTracker.hasActiveRequests$ | async)"
                [text]="'mercer-support.dialog.sent-to-hr' | translate"
                (click)="finalizePositionClass.emit()"></coin-v2-button>
            }
          }
        </div>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ng-template matExpansionPanelContent>
      <div
        class="result"
        [class.disabled]="isLocked()">
        <div class="position-bar">
          <customer-position-class-bar
            [adjustedPositionClass]="
              hidePositionClass ? null : $safeNavigationMigration(memberDetails()?.newPositionClass)
            "
            [derivedPositionClass]="derivedPositionClass()"
            [superiorPositionClass]="
              $safeNavigationMigration(memberDetails()?.superiorPositionClass)
            "></customer-position-class-bar>
        </div>
        @if (dialogType() === mercerDialogType.Support) {
          <div class="adjusted-position-class-reason support">
            <div>
              <p class="bold">
                <mat-icon>info_outline</mat-icon>
                {{ 'mercer-support.dialog.manager-reason-pc-proposal' | translate }}
              </p>
              <p class="reason">{{ memberDetails()?.deviationReason }}</p>
            </div>
          </div>
        }
        @if (dialogType() === mercerDialogType.Manager) {
          <div class="adjusted-position-class-reason manager">
            <div>
              <p>{{ 'mercer-support.dialog.reason-for-pc-change' | translate }}</p>
              <p>{{ 'mercer-support.dialog.mandatory-field' | translate }}</p>
            </div>
            @if (memberDetails()) {
              <coin-v2-text-area
                placeholder="{{ 'mercer-support.dialog.deviation-reason' | translate }}"
                [disabled]="!isEditable()"
                [rows]="3"
                [(ngModel)]="memberDetails().deviationReason"
                (ngModelChange)="emitPermissionChanges()" />
            }
          </div>
        }
        <div
          class="adjusted-position-class"
          [formGroup]="positionForm"
          [class.disabled]="!isEditable() || isLocked()">
          <p class="bold">{{ 'mercer-support.dialog.adjusted-position-class' | translate }}</p>
          <coin-v2-number-input
            [step]="1"
            [placeholder]="'mercer-support.dialog.please-enter-pc' | translate"
            [min]="1"
            [max]="maxPositionClass"
            [matTooltipClass]="isInvalidPcTooltipVisible ? '' : 'display-none'"
            [matTooltip]="'mercer-support.dialog.manager-invalid-pc' | translate"
            [formControl]="positionForm.controls.adjustedPositionClass"
            (ngModelChange)="updateAdjustedPositionClass($event)"></coin-v2-number-input>
          @if (!hideSaveButton()) {
            <coin-v2-button
              type="secondary"
              icon="check"
              iconPos="left"
              [text]="'mercer-support.dialog.save' | translate"
              [disabled]="!(mercerPositionClassService.isSavePositionClassAllowed$ | async) || positionForm.invalid"
              [matTooltip]="'mercer-support.dialog.no-deviation-reason-hint' | translate"
              [matTooltipDisabled]="
                !memberDetails() ||
                dialogType() !== mercerDialogType.Manager ||
                !!memberDetails().deviationReason ||
                !adjustedPositionClass ||
                !isEditable()
              "
              [matTooltipPosition]="'below'"
              (click)="changePositionClass.emit(adjustedPositionClass)"></coin-v2-button>
          }
          @if (positionClassValidationErrors().length || positionClassValidationWarnings().length) {
            <coin-form-info-message
              class="validation-message"
              [errors]="positionClassValidationErrors()"
              [warnings]="positionClassValidationWarnings()"></coin-form-info-message>
          }
          <p>{{ 'mercer-support.dialog.position-class-description' | translate }}</p>
        </div>
      </div>
    </ng-template>
  </mat-expansion-panel>
}
